import { render, staticRenderFns } from "./upvote.vue?vue&type=template&id=16c72cd0"
import script from "./upvote.vue?vue&type=script&lang=ts"
export * from "./upvote.vue?vue&type=script&lang=ts"
import style0 from "./upvote.vue?vue&type=style&index=0&id=16c72cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports